import { gql } from "@apollo/client";

export const DELETE_DOCUMENTO_COTIZACION = gql`
    mutation deleteFileCotizacion(
        $idEvaluacion: Int!
    ){
        deleteFileCotizacion(idEvaluacion: $idEvaluacion) 
    }
`;